import { Grid, IconButton, InputAdornment, TextField, Typography } from '@mui/material';
import React from 'react';
import Visibility from '@mui/icons-material/Visibility'; 
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import theme from '../../muiTheme';

const styles = {
    textField: {
        width: '100%',
        margin: '10px 0px',
        background: theme.palette.faint,
        borderRadius: '15px',

        '& .MuiInputBase-root': {
            borderRadius: '15px'
            
        },

        '& fieldset': {
            borderColor: 'transparent'
        },

        '& fieldset': {
            borderColor: 'transparent'
        },
        
        '& label': {
            transition: '0.4s',
            background: theme.palette.faint,
            padding: '1px 15px',
            borderRadius: '20px',
        },

        '& .MuiInputBase-root input:-internal-autofill-selected': {
            backgroundColor: 'transparent !important'
        },

        '& label.Mui-focused ': {

            padding: '3px 15px',
            borderRadius: '20px',
            marginLeft: '-5px',
            background: theme.palette.primary.main,
            color: 'white'
        }
    },
}

const CustomInput = ({
        half, 
        value, 
        defaultValue, 
        name, 
        label, 
        minRows, 
        maxRows, 
        onChange, 
        placeholder, 
        secondLabel, 
        handleChange,
        helperText,
        required, 
        multiline, 
        autoFocus, 
        handleShowPassword, 
        type, 
        sx, 
        endAdornment, 
        characterLimit = 403, //abitrary default value to decide whether to show character count or not
        characterLimitSx
    }) => {

    let generateEndAdornment = () => {

        let adornment = {}; 

        //let prop override password
        if(endAdornment){

            adornment = endAdornment; 

        } else if(name === 'password' || name === 'confirmPassword') {


            adornment =  {
                endAdornment: (
                    <InputAdornment position='end'>
                        <IconButton onClick={handleShowPassword}>
                            {type === 'password' ? 
                                <Visibility /> 
                                :
                                <VisibilityOff />
                            }
                        </IconButton>
                    </InputAdornment>
                ),
            };
        }

        //if character limit !== 403, shows characters
        // if(characterLimit !== 403){

        //     adornment.startAdornment = (
        //         <InputAdornment position='start'>
                    
        //         </InputAdornment>
        //     )
        // }

        return adornment; 

    }

    const processChange = (event) => {
        //we'll use this as a global input length limiter - The UI/UX side will need to be done later

        let callback = onChange || handleChange;

        let newValue = event.target.value;

        if(newValue.length >= characterLimit+1){


            newValue = value.substr(0, characterLimit); //400 character limit
        }

        if(typeof callback === 'function'){
            event.target.value = newValue; 
            callback(event);
        }

        console.log('event: ', event);

    }

    return (
        <>
            <TextField 
                name={name}
                onChange={processChange}
                variant='outlined'
                type={type}
                value={value}
                defaultValue={defaultValue}
                multiline={multiline}
                minRows={minRows}
                maxRows={maxRows}
                required={required}
                helperText={helperText}
                fullWidth
                placeholder={placeholder}
                label={label}
                autoFocus={autoFocus}
                sx={{...styles.textField, ...sx}}
                InputProps={generateEndAdornment()}
            /> 

            {
                (characterLimit !== 403) &&

                <Typography 
                    variant='subtitle2' 
                    sx={{
                        fontSize: '12px', 
                        color: value.length === characterLimit ? theme.palette.error.main : theme.palette.lightGray, 
                        marginTop: '-15px',
                        ...characterLimitSx
                    }}>
                    {value.length} / {characterLimit}
                </Typography>
            }
            

        </>
        
        
        
    );
}

export default CustomInput; 